import React from "react";

const UzIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="18"
        viewBox="0 0 24 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_177_4854)">
          <path d="M0 12H24V18H0V12Z" fill="#1EB53A" />
          <path d="M0 0H24V6H0V0Z" fill="#0099B5" />
          <path d="M0 5.76001H24V12.24H0V5.76001Z" fill="#CE1126" />
          <path d="M0 6.12H24V11.88H0V6.12Z" fill="white" />
          <path
            d="M5.04 5.04C6.23294 5.04 7.2 4.07294 7.2 2.88C7.2 1.68707 6.23294 0.720001 5.04 0.720001C3.84707 0.720001 2.88 1.68707 2.88 2.88C2.88 4.07294 3.84707 5.04 5.04 5.04Z"
            fill="white"
          />
          <path
            d="M5.76001 5.04C6.95294 5.04 7.92001 4.07294 7.92001 2.88C7.92001 1.68707 6.95294 0.720001 5.76001 0.720001C4.56707 0.720001 3.60001 1.68707 3.60001 2.88C3.60001 4.07294 4.56707 5.04 5.76001 5.04Z"
            fill="#0099B5"
          />
          <path
            d="M9.79122 4.17676L9.65442 4.58716L9.86322 4.65916"
            fill="white"
          />
          <path
            d="M9.79121 4.17676L9.92801 4.58716L9.71921 4.65916"
            fill="white"
          />
          <path
            d="M10.2021 4.47526L9.76948 4.47197L9.76552 4.6928"
            fill="white"
          />
          <path
            d="M10.2021 4.47527L9.85401 4.7322L9.72101 4.55587"
            fill="white"
          />
          <path
            d="M9.38038 4.47527L9.72842 4.7322L9.86142 4.55587"
            fill="white"
          />
          <path
            d="M9.38036 4.47526L9.81295 4.47197L9.8169 4.6928"
            fill="white"
          />
          <path
            d="M10.0451 4.95825L9.9146 4.54582L9.70335 4.6103"
            fill="white"
          />
          <path
            d="M10.0452 4.95826L9.69325 4.70665L9.81985 4.52567"
            fill="white"
          />
          <path
            d="M9.53731 4.95826L9.88921 4.70665L9.7626 4.52567"
            fill="white"
          />
          <path
            d="M9.53731 4.95825L9.66786 4.54582L9.87911 4.6103"
            fill="white"
          />
          <path
            d="M9.79125 2.44876L9.65445 2.85916L9.86325 2.93116"
            fill="white"
          />
          <path
            d="M9.79124 2.44876L9.92804 2.85916L9.71924 2.93116"
            fill="white"
          />
          <path
            d="M10.2021 2.74726L9.76951 2.74398L9.76555 2.96481"
            fill="white"
          />
          <path
            d="M10.2021 2.74728L9.85404 3.0042L9.72104 2.82787"
            fill="white"
          />
          <path
            d="M9.38038 2.74728L9.72842 3.0042L9.86142 2.82787"
            fill="white"
          />
          <path
            d="M9.38036 2.74726L9.81295 2.74398L9.8169 2.96481"
            fill="white"
          />
          <path
            d="M10.0451 3.23025L9.9146 2.81782L9.70335 2.8823"
            fill="white"
          />
          <path
            d="M10.0452 3.23026L9.69325 2.97865L9.81985 2.79767"
            fill="white"
          />
          <path
            d="M9.53731 3.23026L9.88921 2.97865L9.7626 2.79767"
            fill="white"
          />
          <path
            d="M9.53731 3.23025L9.66786 2.81782L9.87911 2.8823"
            fill="white"
          />
          <path
            d="M9.79122 0.720764L9.65442 1.13116L9.86322 1.20316"
            fill="white"
          />
          <path
            d="M9.79121 0.720764L9.92801 1.13116L9.71921 1.20316"
            fill="white"
          />
          <path
            d="M10.2021 1.01926L9.76948 1.01598L9.76552 1.23681"
            fill="white"
          />
          <path
            d="M10.2021 1.01928L9.85401 1.2762L9.72101 1.09987"
            fill="white"
          />
          <path
            d="M9.38038 1.01928L9.72842 1.2762L9.86142 1.09987"
            fill="white"
          />
          <path
            d="M9.38036 1.01926L9.81295 1.01598L9.8169 1.23681"
            fill="white"
          />
          <path
            d="M10.0451 1.50225L9.9146 1.08982L9.70335 1.1543"
            fill="white"
          />
          <path
            d="M10.0452 1.50226L9.69325 1.25065L9.81985 1.06967"
            fill="white"
          />
          <path
            d="M9.53731 1.50226L9.88921 1.25065L9.7626 1.06967"
            fill="white"
          />
          <path
            d="M9.53731 1.50225L9.66786 1.08982L9.87911 1.1543"
            fill="white"
          />
          <path
            d="M11.5192 4.17676L11.3824 4.58716L11.5912 4.65916"
            fill="white"
          />
          <path
            d="M11.5192 4.17676L11.656 4.58716L11.4472 4.65916"
            fill="white"
          />
          <path
            d="M11.9301 4.47526L11.4975 4.47197L11.4936 4.6928"
            fill="white"
          />
          <path
            d="M11.9301 4.47527L11.582 4.7322L11.449 4.55587"
            fill="white"
          />
          <path
            d="M11.1084 4.47527L11.4564 4.7322L11.5894 4.55587"
            fill="white"
          />
          <path
            d="M11.1084 4.47526L11.5409 4.47197L11.5449 4.6928"
            fill="white"
          />
          <path
            d="M11.7731 4.95825L11.6426 4.54582L11.4313 4.6103"
            fill="white"
          />
          <path
            d="M11.7731 4.95826L11.4212 4.70665L11.5479 4.52567"
            fill="white"
          />
          <path
            d="M11.2653 4.95826L11.6172 4.70665L11.4906 4.52567"
            fill="white"
          />
          <path
            d="M11.2653 4.95825L11.3959 4.54582L11.6071 4.6103"
            fill="white"
          />
          <path
            d="M11.5192 2.44876L11.3824 2.85916L11.5912 2.93116"
            fill="white"
          />
          <path
            d="M11.5192 2.44876L11.656 2.85916L11.4472 2.93116"
            fill="white"
          />
          <path
            d="M11.9301 2.74726L11.4975 2.74398L11.4936 2.96481"
            fill="white"
          />
          <path
            d="M11.9301 2.74728L11.582 3.0042L11.449 2.82787"
            fill="white"
          />
          <path
            d="M11.1084 2.74728L11.4564 3.0042L11.5894 2.82787"
            fill="white"
          />
          <path
            d="M11.1084 2.74726L11.5409 2.74398L11.5449 2.96481"
            fill="white"
          />
          <path
            d="M11.7731 3.23025L11.6426 2.81782L11.4313 2.8823"
            fill="white"
          />
          <path
            d="M11.7731 3.23026L11.4212 2.97865L11.5479 2.79767"
            fill="white"
          />
          <path
            d="M11.2653 3.23026L11.6172 2.97865L11.4906 2.79767"
            fill="white"
          />
          <path
            d="M11.2653 3.23025L11.3959 2.81782L11.6071 2.8823"
            fill="white"
          />
          <path
            d="M11.5192 0.720764L11.3824 1.13116L11.5912 1.20316"
            fill="white"
          />
          <path
            d="M11.5192 0.720764L11.656 1.13116L11.4472 1.20316"
            fill="white"
          />
          <path
            d="M11.9301 1.01926L11.4975 1.01598L11.4935 1.23681"
            fill="white"
          />
          <path d="M11.93 1.01928L11.582 1.2762L11.449 1.09987" fill="white" />
          <path
            d="M11.1084 1.01928L11.4564 1.2762L11.5894 1.09987"
            fill="white"
          />
          <path
            d="M11.1084 1.01926L11.5409 1.01598L11.5449 1.23681"
            fill="white"
          />
          <path
            d="M11.7731 1.50225L11.6426 1.08982L11.4313 1.1543"
            fill="white"
          />
          <path
            d="M11.7731 1.50226L11.4212 1.25065L11.5479 1.06967"
            fill="white"
          />
          <path
            d="M11.2653 1.50226L11.6172 1.25065L11.4906 1.06967"
            fill="white"
          />
          <path
            d="M11.2653 1.50225L11.3959 1.08982L11.6071 1.1543"
            fill="white"
          />
          <path
            d="M13.2472 4.17676L13.1104 4.58716L13.3192 4.65916"
            fill="white"
          />
          <path
            d="M13.2472 4.17676L13.384 4.58716L13.1752 4.65916"
            fill="white"
          />
          <path
            d="M13.6581 4.47526L13.2255 4.47197L13.2215 4.6928"
            fill="white"
          />
          <path d="M13.658 4.47527L13.31 4.7322L13.177 4.55587" fill="white" />
          <path
            d="M12.8364 4.47527L13.1844 4.7322L13.3174 4.55587"
            fill="white"
          />
          <path
            d="M12.8364 4.47526L13.2689 4.47197L13.2729 4.6928"
            fill="white"
          />
          <path
            d="M13.5011 4.95825L13.3706 4.54582L13.1593 4.6103"
            fill="white"
          />
          <path
            d="M13.5011 4.95826L13.1492 4.70665L13.2758 4.52567"
            fill="white"
          />
          <path
            d="M12.9933 4.95826L13.3452 4.70665L13.2186 4.52567"
            fill="white"
          />
          <path
            d="M12.9933 4.95825L13.1239 4.54582L13.3351 4.6103"
            fill="white"
          />
          <path
            d="M13.2472 2.44876L13.1104 2.85916L13.3192 2.93116"
            fill="white"
          />
          <path
            d="M13.2472 2.44876L13.384 2.85916L13.1752 2.93116"
            fill="white"
          />
          <path
            d="M13.6581 2.74726L13.2255 2.74398L13.2215 2.96481"
            fill="white"
          />
          <path d="M13.658 2.74728L13.31 3.0042L13.177 2.82787" fill="white" />
          <path
            d="M12.8364 2.74728L13.1844 3.0042L13.3174 2.82787"
            fill="white"
          />
          <path
            d="M12.8364 2.74726L13.2689 2.74398L13.2729 2.96481"
            fill="white"
          />
          <path
            d="M13.5011 3.23025L13.3706 2.81782L13.1593 2.8823"
            fill="white"
          />
          <path
            d="M13.5011 3.23026L13.1492 2.97865L13.2758 2.79767"
            fill="white"
          />
          <path
            d="M12.9933 3.23026L13.3452 2.97865L13.2186 2.79767"
            fill="white"
          />
          <path
            d="M12.9933 3.23025L13.1239 2.81782L13.3351 2.8823"
            fill="white"
          />
          <path
            d="M13.2472 0.720764L13.1104 1.13116L13.3192 1.20316"
            fill="white"
          />
          <path
            d="M13.2472 0.720764L13.384 1.13116L13.1752 1.20316"
            fill="white"
          />
          <path
            d="M13.6581 1.01926L13.2255 1.01598L13.2215 1.23681"
            fill="white"
          />
          <path d="M13.658 1.01928L13.31 1.2762L13.177 1.09987" fill="white" />
          <path
            d="M12.8364 1.01928L13.1844 1.2762L13.3174 1.09987"
            fill="white"
          />
          <path
            d="M12.8364 1.01926L13.2689 1.01598L13.2729 1.23681"
            fill="white"
          />
          <path
            d="M13.5011 1.50225L13.3706 1.08982L13.1593 1.1543"
            fill="white"
          />
          <path
            d="M13.5011 1.50226L13.1492 1.25065L13.2758 1.06967"
            fill="white"
          />
          <path
            d="M12.9933 1.50226L13.3452 1.25065L13.2186 1.06967"
            fill="white"
          />
          <path
            d="M12.9933 1.50225L13.1239 1.08982L13.3351 1.1543"
            fill="white"
          />
          <path
            d="M6.33523 4.17676L6.19843 4.58716L6.40723 4.65916"
            fill="white"
          />
          <path
            d="M6.33522 4.17676L6.47202 4.58716L6.26322 4.65916"
            fill="white"
          />
          <path
            d="M6.74607 4.47526L6.31348 4.47197L6.30953 4.6928"
            fill="white"
          />
          <path
            d="M6.74606 4.47527L6.39802 4.7322L6.26502 4.55587"
            fill="white"
          />
          <path
            d="M5.92438 4.47527L6.27242 4.7322L6.40542 4.55587"
            fill="white"
          />
          <path
            d="M5.92437 4.47526L6.35696 4.47197L6.36091 4.6928"
            fill="white"
          />
          <path
            d="M6.58916 4.95825L6.4586 4.54582L6.24736 4.6103"
            fill="white"
          />
          <path
            d="M6.58916 4.95826L6.23726 4.70665L6.36386 4.52567"
            fill="white"
          />
          <path
            d="M6.08131 4.95826L6.43321 4.70665L6.30661 4.52567"
            fill="white"
          />
          <path
            d="M6.08132 4.95825L6.21187 4.54582L6.42311 4.6103"
            fill="white"
          />
          <path
            d="M8.06325 4.17676L7.92645 4.58716L8.13525 4.65916"
            fill="white"
          />
          <path
            d="M8.06324 4.17676L8.20004 4.58716L7.99124 4.65916"
            fill="white"
          />
          <path
            d="M8.4741 4.47526L8.04151 4.47197L8.03756 4.6928"
            fill="white"
          />
          <path
            d="M8.47408 4.47527L8.12604 4.7322L7.99305 4.55587"
            fill="white"
          />
          <path
            d="M7.65238 4.47527L8.00042 4.7322L8.13342 4.55587"
            fill="white"
          />
          <path
            d="M7.65237 4.47526L8.08495 4.47197L8.08891 4.6928"
            fill="white"
          />
          <path
            d="M8.31715 4.95825L8.1866 4.54582L7.97536 4.6103"
            fill="white"
          />
          <path
            d="M8.31716 4.95826L7.96525 4.70665L8.09186 4.52567"
            fill="white"
          />
          <path
            d="M7.80931 4.95826L8.16121 4.70665L8.03461 4.52567"
            fill="white"
          />
          <path
            d="M7.80931 4.95825L7.93987 4.54582L8.15111 4.6103"
            fill="white"
          />
          <path
            d="M8.06325 2.44876L7.92645 2.85916L8.13525 2.93116"
            fill="white"
          />
          <path
            d="M8.06324 2.44876L8.20004 2.85916L7.99124 2.93116"
            fill="white"
          />
          <path
            d="M8.4741 2.74726L8.04151 2.74398L8.03756 2.96481"
            fill="white"
          />
          <path
            d="M8.47408 2.74728L8.12604 3.0042L7.99305 2.82787"
            fill="white"
          />
          <path
            d="M7.65238 2.74728L8.00042 3.0042L8.13342 2.82787"
            fill="white"
          />
          <path
            d="M7.65237 2.74726L8.08495 2.74398L8.08891 2.96481"
            fill="white"
          />
          <path
            d="M8.31715 3.23025L8.1866 2.81782L7.97536 2.8823"
            fill="white"
          />
          <path
            d="M8.31716 3.23026L7.96525 2.97865L8.09186 2.79767"
            fill="white"
          />
          <path
            d="M7.80931 3.23026L8.16121 2.97865L8.03461 2.79767"
            fill="white"
          />
          <path
            d="M7.80931 3.23025L7.93987 2.81782L8.15111 2.8823"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_177_4854">
            <rect width="24" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default UzIcon;
